import React, { Fragment } from "react";

export default (
  <>
    <path d="M1.7.3c-.5.5-.5 1.2 0 1.7l9.8 10-9.8 10c-.4.5-.4 1.2 0 1.7s1.2.5 1.6 0l10.6-10.8c.4-.5.4-1.2 0-1.7l-.1-.1s0-.1-.1-.1L3.3.3c-.4-.4-1.2-.4-1.6 0z" />
    <path d="M10.2.3c-.5.5-.5 1.2 0 1.7L20 12l-9.8 10c-.4.5-.4 1.2 0 1.7s1.2.5 1.6 0l10.6-10.8c.4-.5.4-1.2 0-1.7l-.1-.1s0-.1-.1-.1L11.8.3c-.4-.4-1.2-.4-1.6 0z" />
  </>
);
